import type { Resource } from '../../';
export const country_countries_HK: Resource = {"default":"Hong Kong"};
